import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, renderSlot as _renderSlot, unref as _unref, withCtx as _withCtx, createBlock as _createBlock } from "vue"

import { IonPopover } from '@ionic/vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'MultiplePopover',
  props: {
    triggers: {
        type: Array,
        required: true
    }
},
  setup(__props) {





return (_ctx: any,_cache: any) => {
  return (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.triggers, (trigger) => {
    return (_openBlock(), _createBlock(_unref(IonPopover), {
      key: trigger,
      class: "popover",
      "keep-contents-mounted": true,
      trigger: trigger,
      "trigger-action": "click"
    }, {
      default: _withCtx(() => [
        _renderSlot(_ctx.$slots, "default")
      ]),
      _: 2
    }, 1032, ["trigger"]))
  }), 128))
}
}

})